export default "__VITE_ASSET__5F_d5Ux2__"